import type { Contact } from "@estelle/domain";

/** A row flattened to the field names its module declares. */
export type Projection = Record<string, unknown>;

/**
 * A contact flattened for display.
 *
 * Deliberately computed from the row and nothing else — read the comment at
 * the top of `modules/orders/projections.ts`, which explains why and applies
 * here unchanged. The adapter's own projection can be richer because it
 * holds the whole dataset; this one cannot join. The list response carries a
 * contact's primary phone and email on the row itself (#551), so they are read
 * from it like any other column; filtering still searches every number and
 * address, on the server. `typeIds` is here because it is the one array
 * `Contact` actually carries — the type badges shown in `ContactList` for a
 * "Type" column come from this, not from a join.
 */
export function projectContact(contact: Contact): Projection {
  return {
    displayName: contact.displayName,
    companyName: contact.companyName ?? "",
    phone: contact.phone ?? "",
    email: contact.email ?? "",
    gstin: contact.gstin ?? "",
    tags: contact.tags,
    typeIds: contact.typeIds,
    isArchived: contact.isArchived,
    createdAt: contact.createdAt,
  };
}
